const FIRST_APP_VERSION_WITH_BACK_EVENT = [1, 2, 4];
/**
 * Backwards compatibility for the Android back button: whether the inbox runs inside a mobile
 * app version that dispatches a 'goBack' window event on every hardware back press (1.2.4+,
 * June 2024). Older apps never send it, so they must keep using 'popstate'. The app appends
 * "MobileApp/x.y.z" to the WebView user agent; browsers and older apps return false.
 */
export function appSendsBackEvent() {
    const match = /MobileApp\/(\d+)\.(\d+)\.(\d+)/.exec(navigator.userAgent);
    if (!window.ReactNativeWebView || !match)
        return false;
    const difference = match
        .slice(1)
        .map((part, i) => Number(part) - FIRST_APP_VERSION_WITH_BACK_EVENT[i])
        .find((diff) => diff !== 0);
    return (difference !== null && difference !== void 0 ? difference : 0) >= 0;
}
